@if (showCoursesPage$()) {
  @if (showCoursesPage$() === 'no-data') {
    <app-no-course [courseTypeId]="courseTypeId"></app-no-course>
  } @else {
    <div class="create_campus_sec " >
      <app-notes-success-popup></app-notes-success-popup>
      @if (successWarningPopupType()) {
        <app-success-or-warning-popup [popupType]="successWarningPopupType()" [displayText]="successOrWarnMsg()" />
      }
      @if (util.saveCourseSuccessPopup$()) {
        <div class="success_created">
          <span class="material-icons done-color">done</span>
          <p> {{ util.saveCourseSuccessPopup$() }} </p>
          <a class="material-icons" (click)="util.saveCourseSuccessPopup$.set('')">close</a>
        </div>
      } @else {
        @if (util.saveSuccessPopup$()) {
          <div class="success_created">
            <span class="material-icons done-color">done</span>
            <p> {{ util.saveSuccessPopup$() }} </p>
            <a class="material-icons" (click)="util.saveSuccessPopup$.set('')">close</a>
          </div>
        }
      }
      <div class="top_flex" [ngClass]="{'er_assigned_course_filter': courseErDialogData}">
        @if (!courseErDialogData) {
          <div class="custom_btn"><img src="/assets/images/icon-left.svg" width="" height="" alt="CUSTOMISE TABLE">
            <p>CUSTOMISE TABLE</p>
          </div>
        }
        <div class="more_btn">
          @if (!courseErDialogData) {
            <div>
              <p class="more_opt_lbl">More </p><span class="material-icons more_color_ch">more_horiz</span>
            </div>
            @if (countryId == constVar.ukCountryId) {
            <div class="stages_module_upd_dwnld" [matMenuTriggerFor]="uploadDownloadMenu" roleAccessControl accessType="stagesModulesDownload" #access="accessControl">
              <p>Manage stages & modules </p>
              <mat-menu class="upload_download_menu_table more_menu" #uploadDownloadMenu="matMenu">
                @if (!['initiate', 'completed'].includes(courseListDetails$()?.initiateStatus?.toLowerCase())) {
                  <button mat-menu-item (click)="downloadStagesModulesReport('init')" roleAccessControl accessType="stagesModulesDownload" #access="accessControl"><span>Initiate Module Report Download</span></button>
                }
                @if (courseListDetails$()?.initiateStatus?.toLowerCase() === 'initiate') {
                  <button mat-menu-item class="disable_menu_button" disabled="true"><span class="disable_report" roleAccessControl accessType="stagesModulesDownload" #access="accessControl">Report Generation in Progress</span></button>
                }
                @if (courseListDetails$()?.initiateStatus?.toLowerCase() === 'completed') {
                  <button mat-menu-item (click)="downloadStagesModulesReport('download')" roleAccessControl accessType="stagesModulesDownload" #access="accessControl"><span>Download Module Report</span></button>
                }
                <button mat-menu-item (click)="openUploadPopup()" [ngClass]="{'disable_menu_button': ['uploading', 'in progress'].includes(courseListDetails$()?.uploadStatus?.toLowerCase())}" [disabled]="['uploading', 'in progress'].includes(courseListDetails$()?.uploadStatus?.toLowerCase())" roleAccessControl accessType="stagesModulesUpload" #access="accessControl"><span [ngClass]="{'disable_report': ['uploading', 'in progress'].includes(courseListDetails$()?.uploadStatus?.toLowerCase())}">Upload Stages and module</span></button>
                <button mat-menu-item (click)="courseCommonFunction.openModuleReportList(institutionDetails, 'stagesModules', 'Module')" [ngClass]="{'disable_menu_button': !courseListDetails$()?.moduleReportCount}" [disabled]="!courseListDetails$()?.moduleReportCount" roleAccessControl accessType="stagesModulesViewReport" #access="accessControl"><span [ngClass]="{'disable_report': !courseListDetails$()?.moduleReportCount}">View module report</span></button>
              </mat-menu>
            </div>
            }
          }
          @if ((searchCourseFields | json) !== '{}') {
            <div class="clear_btn" (click)="clearCourseFilter()">
              <svg width="22" height="22" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path id="myPath" d="M1 2C1 1.44772 1.44772 1 2 1H10C10.5523 1 11 1.44772 11 2V2.80801C11 3.07323 10.8946 3.32758 10.7071 3.51512L7.404 6.81822C7.21647 7.00575 7.11111 7.26011 7.11111 7.52532V8.77778L4.88889 11V7.52533C4.88889 7.26011 4.78353 7.00575 4.596 6.81822L1.29289 3.51512C1.10536 3.32758 1 3.07323 1 2.80801V2Z" stroke="#555555" stroke-width="1.13" stroke-linecap="round" stroke-linejoin="round" />
                <circle id="myPath1" cx="10.5" cy="5.5" r="2.935" fill="#555555" stroke="#555555" stroke-width="1.13" />
                <path id="myPath2" d="M8.37891 5.5L12.6215 5.5" stroke="#ffffff" stroke-width="1.13" />
              </svg>
              <span>Clear Filter</span>
            </div>
          }
          @if (!courseErDialogData) {
            <button (click)="createNewCourse()" class="create_institution gap_btn" mat-stroked-button roleAccessControl accessType="create">
              <span class="material-icons">add</span>CREATE NEW</button>
            }
          </div>
        </div>
        <div class="course_table" [ngClass]="{'er_assigned_course_popup scroll_bar_controll':courseErDialogData, 'no_filter_result': showCoursesPage$() === 'no-result-filter'}">
          <div [ngClass]="{'er_course_details': courseErDialogData}">
            <table mat-table [dataSource]="dataSource()" matSort (matSortChange)="onTableSortedOrderChange($event)" class="mat-elevation-z8">
              <!-- <ng-container matColumnDef="check">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name">
                check
              </th>
              <td mat-cell *matCellDef="let element">
                <div class="serial_no">{{element.check}}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? toggleAllRows() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox class="check_name" disableRipple (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                  [aria-label]="checkboxLabel(row)">
                </mat-checkbox>
              </td>
            </ng-container> -->
            <ng-container matColumnDef="courseName">
              <th mat-header-cell *matHeaderCellDef>
                <span class="heading_name">Title</span>
                <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by name"></span>
                <span class="filter_hover">
                  <div class="filter_column">
                    @if (!searchCourseFields[courseListingFilterDetails.CourseNameFieldId]) {
                      <button class="fliter_icon" (click)="showCourseFilterOption(courseListingFilterDetails.CourseNameFieldId,'Course name', 'AJAX')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                    }
                    @if (searchCourseFields[courseListingFilterDetails.CourseNameFieldId]) {
                      <button class="fliter_icon_clear" (click)="clearCourseFilter(courseListingFilterDetails.CourseNameFieldId)">
                        <div class="tooltip">
                          <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                          <span class="tooltiptext Clear-tooltip">Clear filter</span>
                        </div>
                      </button>
                    }
                  </div>
                  @if (hideShowFilterOption$() && courseData$().filterId === courseListingFilterDetails.CourseNameFieldId) {
                    <app-manage-filter [filterDetails]="courseData$()" (closeFilterPopup)="closeCourseFilterPopup()" (searchIntakeFilter)="searchAppliedCourseFilter($event)"></app-manage-filter>
                  }
                </span>
              </th>
              @if (!courseErDialogData) {
                <td class="instances_table_cell generl-english" mat-cell *matCellDef="let element;">
                  <div class="instances_name">
                    @if (element.newNotes ) {
                      <a class="notes_icon material-icons">insert_drive_file
                        <div class="notes_tooltip">New note added</div>
                      </a>
                    }
                    <a (click)="redirectToEditPage(element, roleAccess?.accessControl)" roleAccessControl #roleAccess="accessControl" [accessPage]="['edit-course', 'view-course']"> {{element.courseName}}</a>
                  </div>
                </td>
              } @else {
                <td mat-cell class="generl-english" *matCellDef="let element"> {{element.courseName}} </td>
              }
            </ng-container>
            <ng-container matColumnDef="courseId">
              <th mat-header-cell *matHeaderCellDef>
                <span class="heading_name">course id</span>
                <!-- <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by course id"></span> -->
                <span class="filter_hover">
                  <div class="filter_column">
                    @if (!searchCourseFields[courseListingFilterDetails.CourseIdFieldId]) {
                      <button class="fliter_icon" (click)="showCourseFilterOption(courseListingFilterDetails.CourseIdFieldId,'Course ID', 'EXACT_MATCH')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                    }
                    @if (searchCourseFields[courseListingFilterDetails.CourseIdFieldId]) {
                      <button class="fliter_icon_clear" (click)="clearCourseFilter(courseListingFilterDetails.CourseIdFieldId)">
                        <div class="tooltip">
                          <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                          <span class="tooltiptext Clear-tooltip">Clear filter</span>
                        </div>
                      </button>
                    }
                  </div>
                  @if (hideShowFilterOption$() && courseData$().filterId === courseListingFilterDetails.CourseIdFieldId) {
                    <app-manage-filter [filterDetails]="courseData$()" (closeFilterPopup)="closeCourseFilterPopup()" (searchIntakeFilter)="searchAppliedCourseFilter($event)"></app-manage-filter>
                  }
                </span>
              </th>
              <td mat-cell *matCellDef="let element"> {{element.courseId}} </td>
            </ng-container>
            <ng-container matColumnDef="courseType">
              <th mat-header-cell *matHeaderCellDef>
                <span class="heading_name">Course Type</span>
                <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by type"></span>
                <span class="filter_hover">
                  <div class="filter_column">
                    @if (!searchCourseFields[courseListingFilterDetails.CourseTypeFieldId]) {
                      <button class="fliter_icon" (click)="showCourseFilterOption(courseListingFilterDetails.CourseTypeFieldId,'Course type', 'SELECT_BOX')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                    }
                    @if (searchCourseFields[courseListingFilterDetails.CourseTypeFieldId]) {
                      <button class="fliter_icon_clear" (click)="clearCourseFilter(courseListingFilterDetails.CourseTypeFieldId)">
                        <div class="tooltip">
                          <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                          <span class="tooltiptext Clear-tooltip">Clear filter</span>
                        </div>
                      </button>
                    }
                  </div>
                  @if (hideShowFilterOption$() && courseData$().filterId === courseListingFilterDetails.CourseTypeFieldId) {
                    <app-manage-filter [filterDetails]="courseData$()" (closeFilterPopup)="closeCourseFilterPopup()" (searchIntakeFilter)="searchAppliedCourseFilter($event)"></app-manage-filter>
                  }
                </span>
              </th>
              <td mat-cell *matCellDef="let element" title="{{element.courseType}}">
                <div class="Qualification_head"> {{element.courseType}} </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="applicableForFastlane">
              <th mat-header-cell *matHeaderCellDef>
                <span class="heading_name">Applicable to Fastlane</span>
                <span class="filter_hover">
                  <div class="filter_column">
                    @if (!searchCourseFields[courseListingFilterDetails.ApplicableToFastlane]) {
                      <button class="fliter_icon" (click)="showCourseFilterOption(courseListingFilterDetails.ApplicableToFastlane,'Applicable To Fastlane', 'SELECT_BOX')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                    }
                    @if (searchCourseFields.hasOwnProperty(courseListingFilterDetails.ApplicableToFastlane)) {
                      <button class="fliter_icon_clear" (click)="clearCourseFilter(courseListingFilterDetails.ApplicableToFastlane)">
                        <div class="tooltip">
                          <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                          <span class="tooltiptext Clear-tooltip">Clear filter</span>
                        </div>
                      </button>
                    }
                  </div>
                  @if (hideShowFilterOption$() && courseData$().filterId === courseListingFilterDetails.ApplicableToFastlane) {
                    <app-manage-filter [filterDetails]="courseData$()" (closeFilterPopup)="closeCourseFilterPopup()" (searchIntakeFilter)="searchAppliedCourseFilter($event)"></app-manage-filter>
                  }
                </span>
              </th>
              <td mat-cell *matCellDef="let element" class="fastlane_applicable_col"> {{util.dataTypeOf(element.applicableForFastlane) === 'boolean' ? (element.applicableForFastlane ? 'Yes' : 'No') : 'No data'}} </td>
            </ng-container>
            <ng-container matColumnDef="courseCodeType">
              <th mat-header-cell *matHeaderCellDef>
                <span class="heading_name"> code type</span>
              </th>
              <td mat-cell *matCellDef="let element">{{element.courseCodeValues?.courseCodeType}}</td>
            </ng-container>
            <ng-container matColumnDef="courseCode">
              <th mat-header-cell *matHeaderCellDef>
                <span class="heading_name"> code</span>
                <span class="filter_hover">
                  <div class="filter_column">
                    @if (!searchCourseFields[courseListingFilterDetails.CourseCodeFieldId]) {
                      <button class="fliter_icon" (click)="showCourseFilterOption(courseListingFilterDetails.CourseCodeFieldId,'Code', 'EXACT_MATCH')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                    }
                    @if (searchCourseFields[courseListingFilterDetails.CourseCodeFieldId]) {
                      <button class="fliter_icon_clear" (click)="clearCourseFilter(courseListingFilterDetails.CourseCodeFieldId)">
                        <div class="tooltip">
                          <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                          <span class="tooltiptext Clear-tooltip">Clear filter</span>
                        </div>
                      </button>
                    }
                  </div>
                  @if (hideShowFilterOption$() && courseData$().filterId === courseListingFilterDetails.CourseCodeFieldId) {
                    <app-manage-filter [filterDetails]="courseData$()" (closeFilterPopup)="closeCourseFilterPopup()" (searchIntakeFilter)="searchAppliedCourseFilter($event)"></app-manage-filter>
                  }
                </span>
              </th>
              <td mat-cell *matCellDef="let element">{{element.courseCodeValues?.courseCode}}</td>
            </ng-container>
            <ng-container matColumnDef="studyLevel">
              <th mat-header-cell *matHeaderCellDef>
                <span class="heading_name">study level</span>
                <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by name"></span>
                <span class="filter_hover">
                  <div class="filter_column">
                    @if (!searchCourseFields[courseListingFilterDetails.StudyLevelFieldId]) {
                      <button class="fliter_icon" (click)="showCourseFilterOption(courseListingFilterDetails.StudyLevelFieldId,'Study level', 'SELECT_BOX')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                    }
                    @if (searchCourseFields[courseListingFilterDetails.StudyLevelFieldId]) {
                      <button class="fliter_icon_clear" (click)="clearCourseFilter(courseListingFilterDetails.StudyLevelFieldId)">
                        <div class="tooltip">
                          <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                          <span class="tooltiptext Clear-tooltip">Clear filter</span>
                        </div>
                      </button>
                    }
                  </div>
                  @if (hideShowFilterOption$() && courseData$().filterId === courseListingFilterDetails.StudyLevelFieldId) {
                    <app-manage-filter [filterDetails]="courseData$()" (closeFilterPopup)="closeCourseFilterPopup()" (searchIntakeFilter)="searchAppliedCourseFilter($event)"></app-manage-filter>
                  }
                </span>
              </th>
              <td mat-cell *matCellDef="let element"> {{element.studyLevel}} </td>
            </ng-container>
            <ng-container matColumnDef="qualification">
              <th mat-header-cell *matHeaderCellDef>
                <span class="heading_name">qualification</span>
                <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by name"></span>
                <span class="filter_hover">
                  <div class="filter_column">
                    @if (!searchCourseFields[courseListingFilterDetails.QualificationFieldId]) {
                      <button class="fliter_icon" (click)="showCourseFilterOption(courseListingFilterDetails.QualificationFieldId,'Qualification', 'SELECT_BOX')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                    }
                    @if (searchCourseFields[courseListingFilterDetails.QualificationFieldId]) {
                      <button class="fliter_icon_clear" (click)="clearCourseFilter(courseListingFilterDetails.QualificationFieldId)">
                        <div class="tooltip">
                          <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                          <span class="tooltiptext Clear-tooltip">Clear filter</span>
                        </div>
                      </button>
                    }
                  </div>
                  @if (hideShowFilterOption$() && courseData$().filterId === courseListingFilterDetails.QualificationFieldId) {
                    <app-manage-filter [filterDetails]="courseData$()" (closeFilterPopup)="closeCourseFilterPopup()" (searchIntakeFilter)="searchAppliedCourseFilter($event)"></app-manage-filter>
                  }
                </span>
              </th>
              <td mat-cell *matCellDef="let element" title="{{element.qualification}}">
                <div class="Qualification_head"> {{element.qualification}} </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="courseInstanceCount">
              <th mat-header-cell *matHeaderCellDef>
                <span class="heading_name"> instances</span>
                <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by name"></span>
              </th>
              <td mat-cell *matCellDef="let element">
                <div class="instances_name" roleAccessControl accessType="viewList" #roleAccess="accessControl">
                  <a (click)="!courseErDialogData ? showCourseInstanceList(element) : openInstanceListPopup(element)">{{element.courseInstanceCount}}</a>
                </div>
                @if (!roleAccess?.accessControl) {
                  {{element.courseInstanceCount}}
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>
                <span class="heading_name">Status</span>
                <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by name"></span>
                <span class="filter_hover">
                  <div class="filter_column">
                    @if (!searchCourseFields[courseListingFilterDetails.StatusFieldId]) {
                      <button class="fliter_icon" (click)="showCourseFilterOption(courseListingFilterDetails.StatusFieldId,'Status', 'SELECT_BOX')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                    }
                    @if (searchCourseFields[courseListingFilterDetails.StatusFieldId]) {
                      <button class="fliter_icon_clear" (click)="clearCourseFilter(courseListingFilterDetails.StatusFieldId)">
                        <div class="tooltip">
                          <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                          <span class="tooltiptext Clear-tooltip">Clear filter</span>
                        </div>
                      </button>
                    }
                  </div>
                  @if (hideShowFilterOption$() && courseData$().filterId === courseListingFilterDetails.StatusFieldId) {
                    <app-manage-filter [filterDetails]="courseData$()" (closeFilterPopup)="closeCourseFilterPopup()" (searchIntakeFilter)="searchAppliedCourseFilter($event)"></app-manage-filter>
                  }
                </span>
              </th>
              <td mat-cell *matCellDef="let element">
                <div class="course_status {{element.status | lowercase}}">{{element.status}}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="menu">
              <th mat-header-cell *matHeaderCellDef aria-label="row actions" [ngClass]="{'hide_column':courseErDialogData}">&nbsp;</th>
              <td class="menu_bar" [matMenuTriggerFor]="menu" mat-cell *matCellDef="let element" [ngClass]="{'hide_column':courseErDialogData}">
                <span class="material-icons">more_horiz</span>
                <mat-menu class="course_menu" #menu="matMenu">
                  <!-- <button mat-menu-item (click)="redirectToEditPage(element, 'view')">
                  <span>View</span>
                </button> -->
                <button (click)="openConfirmationPopup(element)" mat-menu-item roleAccessControl [accessType]="(element?.status?.toLowerCase()!=='archived')?'archive':'unarchive'">
                  <span> {{ element.status != 'ARCHIVED' ? 'Archive' : 'Unarchive' }} </span>
                </button>
                <button mat-menu-item (click)="notesCommonFn.openNotesDialog('Course', element.courseId,'manage-course')" roleAccessControl accessType="addNotes">
                  <span>Add notes</span>
                </button>
                <button (click)="viewNotes(element.courseId)" mat-menu-item roleAccessControl accessType="viewNotes">
                  <span>View notes</span>
                </button>
                <button (click)="showCourseInstanceList(element)" mat-menu-item roleAccessControl accessType="viewList">
                  <span>View instance list</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.active]="row.courseNew"></tr>
        </table>
      </div>
      <!-- no-data-found -->
      @if (showCoursesPage$() === 'no-result-filter') {
        <div class="no_data_section">
          <div class="no_data_alignment">
            <div class="no_data_avail">No records available</div>
            <div class="no_data_descript">There are no records to display for the selected filter(s)</div>
            <img src="../../../../assets/images/top-icon/no-data-found.svg" alt="">
          </div>
        </div>
      }
      <!-- no-data-found -->
    </div>
    @if (totalRecordCount$()) {
      <app-page-navigation pageName="manage-campus" [totalCount]='totalRecordCount$()'
      [currentPage]='pageNumber$()' (selectedPage)='getPaginationDetails($event)'></app-page-navigation>
    }
  </div>
}
}